import { ADD_NOTIFICATION, GET_NOTIFICATION_ALL, SET_UNREAD_NOTIFICATION_STATUS } from './types';
import notificationService from '../../components/Services/notification.service';

export const getAllNotifications = () => async (dispatch) => {
    notificationService.getAllNotifications()
        .then((response) => {
            if (response && response.data.code === 200) {
                const notifications = response?.data?.data;
                dispatch({ type: GET_NOTIFICATION_ALL, payload: notifications});
                const unreadNotificationsObj = {};
                notifications.map(notification => {
                    if(!notification.readStatus && !unreadNotificationsObj[notification.capacityName] ){
                        // unreadNotificationsObj[notification.capacityName] = constants[notification.notificationEvent];
                        unreadNotificationsObj[notification.capacityName] = notification.content;
                        // console.log("actionNOtifi===>",notification.notificationEvent,constants[notification.notificationEvent],notification.capacityName);
                    }
                })
                dispatch({ type: SET_UNREAD_NOTIFICATION_STATUS, payload: unreadNotificationsObj})
            }
        }).catch(err => console.log(err)
        )
};

export const addNotification = (notification) => {
    return {
      type: ADD_NOTIFICATION,
      payload: notification,
    };
  };
